export default "__VITE_ASSET__C6wrpf58__"